import { findFromObj } from "@app/_core/utility";

const monthsToYears = (value) => {
  const monthOverflow = value % 12;
  const years = Math.floor(value / 12);
  if (monthOverflow === 1 && years === 1) {
    return `${years} aasta ${monthOverflow} kuu`;
  }
  if (monthOverflow > 1 && years === 1) {
    return `${years} aasta ${monthOverflow} kuud`;
  }
  if (monthOverflow > 1 && years > 1) {
    return `${years} aastat ${monthOverflow} kuud`;
  }
  if (monthOverflow === 0 && years > 1) {
    return `${years} aastat`;
  }
  if (monthOverflow > 0 && years === 0) {
    return `${monthOverflow} kuud`;
  }
  return `${years} aasta`;
};

export const parseData = (data) => {
  const tableValues = [
    {
      key: 'fieldEducationalInstitution.0.title',
      label: 'school.institution_name',
    },
    {
      key: 'fieldStudyProgrammeLevel',
      label: 'studyProgramme.level',
    },
    {
      key: 'fieldDegreeOrDiplomaAwarded',
      label: 'studyProgramme.degree_or_diploma',
    },
    {
      key: 'fieldSpecialization',
      label: 'studyProgramme.specialization',
    },
    {
      key: 'fieldIscedfBoard',
      label: 'studyProgramme.filter_iscedf_broad',
    },
    {
      key: 'fieldIscedfNarrow',
      label: 'studyProgramme.filter_iscedf_narrow',
    },
    {
      key: 'fieldIscedfDetailed',
      label: 'studyProgramme.filter_iscedf_detailed',
    },
    {
      key: 'fieldShortDescription',
      label: 'studyProgramme.introduction',
    },
    {
      key: 'fieldTeachingLanguage',
      label: 'studyProgramme.languages',
    },
    {
      key: 'fieldAmount',
      label: 'studyProgramme.study_capacity',
      join: 'fieldAmountUnit',
    },
    {
      key: 'fieldPracticalTrainingAmount',
      label: 'studyProgramme.internship_capacity',
      join: 'fieldAmountUnit',
    },
    {
      key: 'fieldDuration',
      label: 'studyProgramme.nominal_time',
      transform: 'toYears',
    },
    {
      key: 'fieldWebPageAddress.uri',
      label: 'studyProgramme.describing_website',
      transform: 'link',
      linkLabel: 'Vaata õppekava kirjeldust õppeasutuse veebilehel',
    },
    {
      key: 'fieldQualificationStandardId',
      label: 'studyProgramme.qualification_standards',
    },
  ].map((item) => {
    let value: any = findFromObj(data, item.key);

    if (Array.isArray(value) && value.length > 0) {
      const existingValues = [];
      value = value.filter((item) => {
        if (!existingValues.includes(item)) {
          existingValues.push(item);
          return item;
        }
      }).map((item) => {
        return item;
      }).map((item:string) => {
        return item.charAt(0).toUpperCase() + item.slice(1);
      }).join(', ');
    }

    if (item.join && value !== null && value !== '0' && value) {
      value = `${value} ${findFromObj(data, item.join)}`;
    }

    switch (item.transform) {
      case 'toYears': {
        value = monthsToYears(value);
        break;
      }
      case 'link': {
        if (value) {
          value = `<a href="${value}">${item.linkLabel}</a>`;
        }
        break;
      }
    }

    if (value) {
      return {
        value,
        ... item,
      };
    }
  }).filter((item:any) => {
    let output = item;
    if (output) {
      if (Array.isArray(output.value) && output.value.length === 0) {
        output = false;
      }

      if (output.key === 'fieldSpecialization' && output.value.toLowerCase() === 'määramata') {
        output = false;
      }
    }

    return output || false;
  });

  return tableValues;

};
